import React from 'react'
import Link from 'gatsby-link'

import PostPreview from '../components/PostPreview'
import NewsletterPanel from '../components/NewsletterPanel'

const Blog = ({ data }) => {
  return (
    <section className="container">
      <div className="columns">
        <div className="column is-8">
          <div className="post-list">
            {data.posts.edges.map(({ node }) => <PostPreview post={node} key={node.id} />)}
          </div>
        </div>
        <div className="column is-4">
          <NewsletterPanel />
        </div>
      </div>
    </section>
  )
}

export default Blog

export const pageQuery = graphql`
  query HomepagePostsQuery {
    posts: allContentfulPost(sort: { order: DESC fields: [date] }) {
      edges {
        node {
          title
          id
          slug
          description
          mainImage {
            sizes(maxWidth: 600 maxHeight: 300 resizingBehavior: FILL cropFocus: FACES) {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
            description
            title
          }
          authors {
            name
            slug
            description
            profilePicture {
              sizes(maxWidth: 200 maxHeight: 200 resizingBehavior: FILL cropFocus: FACES) {
                base64
                aspectRatio
                src
                srcSet
                sizes
              }
              description
              title
            }
          }
          tags
          date
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/index.js